export default __webpack_public_path__ + "static/media/ServiceReport.13538ff0.mrt";